import theme from '../../theme';

const TableFurniture = ({ color = theme.colors.gray, width = '22', height = '22' }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 100 125" fill={color} xmlns="http://www.w3.org/2000/svg">
      <path fill-rule="evenodd" d="M79.348 25.714H20.652V84H10.87V25.714H5V16h90v9.714h-5.87V84h-9.782V25.714Z"/>
    </svg>
  );
};

export default TableFurniture;
